import { render, staticRenderFns } from "./OneTimePassInputPane.vue?vue&type=template&id=1977ce64&scoped=true"
import script from "./OneTimePassInputPane.vue?vue&type=script&lang=ts"
export * from "./OneTimePassInputPane.vue?vue&type=script&lang=ts"
import style0 from "./OneTimePassInputPane.vue?vue&type=style&index=0&id=1977ce64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1977ce64",
  null
  
)

export default component.exports